import { SearchIcon } from "@/components/icons/SearchIcon";
import { cn } from "@costar-ui/cosmos";

type FilterToolbarSearchIconProps = {
  openFiltersMessage: () => string;
  onFilterIconClick: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  isAuthenticated?: boolean;
};

export const FilterToolbarSearchIcon = ({
  openFiltersMessage,
  onFilterIconClick,
  isAuthenticated,
}: FilterToolbarSearchIconProps) => {
  return (
    <button
      onClick={onFilterIconClick}
      className={cn("border-neutral-medium flex items-center border-l pl-2", {
        "pointer-events-none": !isAuthenticated,
      })}
    >
      <SearchIcon altText={openFiltersMessage() || ""} />
    </button>
  );
};
